import React from 'react'

import { Container, Button } from 'react-bootstrap'
import { Modal, ModalManager, Effect } from 'react-dynamic-modal'
import moment from 'moment'

import './index.css'

function DeviceNotificationDetails({ data }) {

    const style = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 99999999,
            overflowX: 'hidden',
            overflowY: 'auto',
            perspective: 1300,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },

        content: {
            position: 'relative',
            border: '1px solid rgba(0, 0, 0, .2)',
            width: 'inherit',
            background: '#fff',
            overflow: 'auto',
            borderRadius: '4px',
            outline: 'none',
            boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
        }
    }


    return (
        <div className="DeviceNotificationDetails">
            <Modal
                style={style}
                onRequestClose={() => { }}
                effect={Effect.Fall}>
                <div className="header">
                    <div className="title">
                        Detalhes do alerta
                        </div>
                </div>
                <div className="body">
                    <Container fluid>
                        <table className="table table-bordered table-striped">
                            <tbody>
                                <tr>
                                    <td><strong>Mensagem</strong></td>
                                    <td>{data.message}</td>
                                </tr>
                                <tr>
                                    <td><strong>Data da ocorrência</strong></td>
                                    <td>{moment.utc(data.date).local().format('DD/MM/YYYY HH:mm:ss')}</td>
                                </tr>
                                <tr>
                                    <td><strong>Tipo do alarme</strong></td>
                                    <td>{data.type_formatted}</td>
                                </tr>
                                <tr>
                                    <td><strong>Temperatura (Min - Max)</strong></td>
                                    <td>{data.temperature_formatted}</td>
                                </tr>
                                <tr>
                                    <td><strong>Umidade (Min - Max)</strong></td>
                                    <td>{data.humidity_formatted}</td>
                                </tr>
                                <tr>
                                    <td><strong>Ativo</strong></td>
                                    <td>{data.active_formatted}</td>
                                </tr>
                                <tr>
                                    <td><strong>Reconhecido?</strong></td>
                                    <td>{data.acknowledge_formatted}</td>
                                </tr>
                                <tr>
                                    <td><strong>Mensagem de reconhecimento</strong></td>
                                    <td>{data.acknowledge != null ? data.acknowledge.message != null ? data.acknowledge.message : '--' : '--'}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="footer">
                            <Button varianty="primary" onClick={() => ModalManager.close()}>Fechar</Button>
                        </div>
                    </Container>
                </div>
            </Modal>
        </div>
    )
}

export default DeviceNotificationDetails